import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';

const baseUrl = envConfig.formalServer + '/cotton/admin/resource/download/auth/';

function baseApi() {

    function insert(data) {
        return Post(baseUrl + 'insertResourceDownloadAuth', data);
    }

    function deleteData(data) {
        return Post(baseUrl + 'deleteResourceDownloadAuth', data);
    }

    function update(data) {
        return Post(baseUrl + 'updateResourceDownloadAuth', data);
    }

    function query(data, projectName) {
        return Post(baseUrl + 'queryResourceDownloadAuth', data);
    }

    return {
        insert, deleteData, update, query
    };
}

export const resourceDownloadAuthApi = baseApi();
